// Idea: https://github.com/erikras/redux-form/blob/master/src/events/isEvent.js
export default function isEvent(x) {
  return x && ['stopPropagation', 'preventDefault'].every((prop) => !!x[prop]);
}
